import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import ReactTooltip from "react-tooltip";

import ManagerTabSection from "../components/ManagerTabSection";
import Dashboard from "./View/Dashboard";
import Leaderboard from "./View/Leaderboards";
import PushNotification from "./View/PushNotifications";

import ProgramAdmin from "./View/ProgramAdmin";
import SocialWallPanel from "@/containers/Participant/Home/socialWall/SocialWallPanel";
import { getAuthProgram } from "@/containers/App/auth";
import { getBalance } from "@/services/program/getBalance";
import { connect } from "react-redux";
import AwardApprovals from "./View/AwardApprovals";
import InviteApprovalPendingCard from "./View/InviteApprovalPending";
import { amountToUsFormat} from '@/shared/helpers'
import { getManagerCascadingApprovalsCount } from "@/services/program/budget";

const Home = ({ program, organization }) => {
  const [balance, setBalance] = useState(0);

  useEffect(() => {
    if (organization && program) {
      getBalance(organization.id, program.id)
        .then((data) => {
          setBalance(data);
        })
        .catch((error) => {
          console.log(error.response.data);
        });
    }
  }, [organization, program]);

  useEffect(() => {
    const timeoutId = setTimeout(() => ReactTooltip.rebuild(), 0);
    return () => clearTimeout(timeoutId);
  }, [balance]);

  return (
    <div className="manager-home">
      <ReactTooltip place="top" type="dark" effect="solid" className="app-tooltip--elevated" />
      <Container className="manager-home__shell">
        <section className="manager-home__masthead">
          <div className="manager-home__nav">
            <ManagerTabSection />
          </div>
          {Boolean(program?.is_pay_in_advance) && (
            <div
              className="manager-home__balance"
              data-tip="Current available program balance"
            >
              <span className="manager-home__balance-label">
                Balance
              </span>
              <strong className="manager-home__balance-value">
                {amountToUsFormat(balance, true, "$")}
              </strong>
            </div>
          )}
        </section>
      </Container>
      <Dashboard />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    program: state.program,
    organization: state.organization,
    rootProgram: state.rootProgram,
    auth: state.auth,
  };
};
export default connect(mapStateToProps)(Home);

export const ManagerShell = ({ children }) => (
  <div className="manager-home">
    <Container className="manager-home__shell">
      <section className="manager-home__masthead">
        <div className="manager-home__nav">
          <ManagerTabSection />
        </div>
      </section>
    </Container>
    {children}
  </div>
);

export const NSpireWall = () => {
  const program = getAuthProgram();
  if (!program.uses_social_wall) return null;

  return (
    <ManagerShell>
      <SocialWallPanel isManager={true} />
    </ManagerShell>
  );
};

export const Leaderboards = () => (
  <ManagerShell>
    <Leaderboard />
  </ManagerShell>
);

// A referral-submission pending award is created regardless of use_cascading_approvals
// (ReferralService never reads that flag) — it's the only thing that would ever be
// pending on a program with cascading approvals off, since every other award type
// auto-issues immediately in that state. Without this, a manager on a non-cascading
// program could never see or approve a referrer's pending award (ICOV3-1780).
export const AwardApprovalsIndex = ({ organization, auth, program, rootProgram }) => {
  const cascadingOn = Boolean(program.rootProgram?.use_cascading_approvals);
  const [referralPendingCount, setReferralPendingCount] = useState(0);

  useEffect(() => {
    if (cascadingOn || !organization?.id || !program?.id) return;
    getManagerCascadingApprovalsCount(organization, program, "referral")
      .then((res) => setReferralPendingCount(res?.data?.managerApprovalPendingCount ?? 0))
      .catch((error) => console.log(error));
  }, [organization, program, cascadingOn]);

  if (!cascadingOn && referralPendingCount <= 0) return null;

  return (
    <ManagerShell>
      <Container className="manager-home__shell manager-home__content">
        <AwardApprovals organization={organization} auth={auth} rootProgram={rootProgram} />
      </Container>
    </ManagerShell>
  );
};

const AwardApproval = connect(mapStateToProps)(AwardApprovalsIndex);
export { AwardApproval };

const InviteApprovalPendingIndex = ({ organization, auth, program, rootProgram }) => (
  <ManagerShell>
    <Container className="manager-home__shell manager-home__content">
      <InviteApprovalPendingCard organization={organization} auth={auth} rootProgram={rootProgram} />
    </Container>
  </ManagerShell>
);

const InviteApprovalPending = connect(mapStateToProps)(InviteApprovalPendingIndex);
export { InviteApprovalPending };

export const PushNotifications = () => (
  <ManagerShell>
    <Container className="manager-home__shell manager-home__content">
      <PushNotification />
    </Container>
  </ManagerShell>
);

export const ProgramAdminView = () => (
  <ManagerShell>
    <Container className="manager-home__shell manager-home__content">
      <ProgramAdmin />
    </Container>
  </ManagerShell>
);
